import './assets/styles/main.css'
import Vue from 'vue'
import App from './App.vue'
import request from '@/utils/request'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueRouter from 'vue-router'
import router from './router'
import Vuex from 'vuex'
import store from './store'
import Cookies from 'js-cookie'
import i18n from '@/lang'
import plugins from './plugins'
import { parseTime, resetForm, addDateRange, selectDictLabel, selectDictLabels, handleTree } from "@/utils/systemUtil";
import Pagination from "@/components/Pagination" //分页组件
import SvgIcon from '@/components/SvgIcon'// svg component
import secondaryPassword from '@/views/system/secondaryPassword/index.vue'

// register globally
Vue.component('svg-icon', SvgIcon)
// 全局方法挂载
Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.addDateRange = addDateRange
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.selectDictLabels = selectDictLabels
Vue.prototype.handleTree = handleTree

Vue.config.productionTip = false
Vue.prototype.$request = request

Vue.component("my-pagination", Pagination)
Vue.component("secondary-password", secondaryPassword)

Vue.use(ElementUI)
Vue.use(VueRouter)
Vue.use(Vuex)
Vue.use(Cookies)
Vue.use(plugins)

new Vue({
  render: h => h(App),
  router,
  store,
  i18n
}).$mount('#app')
